module.exports = __webpack_public_path__ + "static/media/竖版视频.7d08a90.MP4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/竖版视频.MP4
// module id = beLE
// module chunks = 3